(function(){
"use strict";
var money = function(n){ return "$" + (Number(n)||0).toLocaleString("en-US",{minimumFractionDigits:2,maximumFractionDigits:2}); };
var getEl = function(s,el){ return (el||document).querySelector(s); };
var getAll = function(s,el){ return Array.prototype.slice.call((el||document).querySelectorAll(s)); };
var lastData = null;
// Catalog search dropdown styles
var srStyle = document.createElement("style");
srStyle.textContent = ".rfq-sr{position:absolute;top:100%;left:0;right:0;z-index:60;background:#fff;border:1px solid #C9CED7;border-radius:8px;box-shadow:0 10px 26px rgba(20,36,59,.14);margin-top:4px;overflow:hidden}.rfq-sr:empty{display:none}.rfq-sr-item{display:flex;align-items:center;gap:10px;width:100%;padding:9px 11px;background:#fff;border:0;cursor:pointer;text-align:left;font-family:inherit}.rfq-sr-item:hover{background:#F4F6F8}.rfq-sr-thumb{width:30px;height:30px;border-radius:4px;background-size:cover;background-position:center;flex:none;border:1px solid #E3E7EC}.rfq-sr-name{flex:1;font-size:13px;line-height:1.35}.rfq-sr-price{font-size:12.5px;color:#5B6472;white-space:nowrap}.rfq-sr-empty{padding:9px 11px;font-size:12.5px;color:#5B6472}";
document.head.appendChild(srStyle);
// Reference number + date
var now = new Date();
var ref = "RFQ-" + now.getFullYear() + "-" + Math.floor(1000 + Math.random()*9000);
var dateStr = now.toLocaleDateString("en-US",{year:"numeric",month:"short",day:"numeric"});
var el; el=getEl("#refNo"); if(el) el.textContent=ref;
el=getEl("#refDate"); if(el) el.textContent=dateStr;
el=getEl("#docRef"); if(el) el.textContent=ref;
el=getEl("#docDate"); if(el) el.textContent=dateStr;
function esc(s){ return String(s==null?"":s).replace(/[&<>"]/g,function(c){return{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c];}); }
// ---- Post-submit confirmation view: restore the submitted request into the recap card ----
var confirmCard = document.querySelector(".rfq-confirm");
if (confirmCard) {
var saved = null;
try { saved = JSON.parse(sessionStorage.getItem("rfqLastRequest")||"null"); } catch(e) {}
if (saved && saved.items && saved.items.length) {
el=getEl("#refNo"); if(el) el.textContent=saved.ref||"—";
el=getEl("#refDate"); if(el) el.textContent=saved.date||dateStr;
var sUnits=0, sSub=0;
saved.items.forEach(function(it){ sUnits+=(it.qty||0); if(it.priced) sSub+=(it.price||0)*(it.qty||0); });
el=getEl("#rcBuyer"); if(el) el.textContent=saved.buyer||"—";
el=getEl("#rcItems"); if(el) el.textContent=saved.items.length;
el=getEl("#rcUnits"); if(el) el.textContent=sUnits;
el=getEl("#rcNeed"); if(el) el.textContent=saved.needBy||"—";
el=getEl("#rcTotal"); if(el) el.textContent=money(sSub);
var list=document.createElement("div");
list.style.cssText="max-width:440px;margin:14px auto 0;text-align:left;font-size:13.5px;color:#39424E;border-top:1px solid #E3E7EC;padding-top:12px";
list.innerHTML='<b style="font-size:12px;letter-spacing:.04em;text-transform:uppercase;color:#5B6472">Your request &mdash; '+esc(saved.ref||"")+'</b>'+saved.items.map(function(it){ return '<div style="margin-top:6px">'+esc((it.qty||1)+"x "+(it.name||"item"))+(it.sku?' <span style="color:#5B6472">[SKU '+esc(it.sku)+']</span>':'')+(it.priced?' &mdash; est '+money((it.price||0)*(it.qty||1)):'')+'</div>'; }).join("");
var subEl=confirmCard.querySelector(".rfq-sub");
if(subEl&&subEl.parentNode) subEl.parentNode.insertBefore(list,subEl.nextSibling);
} else {
var recapEl=document.querySelector(".rfq-recap"); if(recapEl) recapEl.style.display="none";
}
}
// ---- Line items ----
var params = new URLSearchParams(window.location.search);
var items = [];
// CSS-safe background-image value: single quotes inside the double-quoted style attribute
function bgUrl(u){ return "background-image:url('" + String(u).replace(/['"()\s]/g,"") + "')"; }
var primary = {
name: params.get("product") || "",
sku:  params.get("sku")     || "",
price: parseFloat(params.get("price")) || 0,
image: params.get("image")  || "",
qty:  Math.max(1, parseInt(params.get("qty"),10) || 1),
fixed: true
};
// Only lock in a primary row when a product actually arrived via URL params.
if (primary.name || primary.sku) {
items.push(primary);
} else {
items.push({name:"",sku:"",price:0,qty:1,fixed:false});
}
var rows = getEl("#itemRows");
function render(){
rows = getEl("#itemRows");
if (!rows) return;
rows.innerHTML = "";
items.forEach(function(it, i){
var tr = document.createElement("tr");
var hasPrice = (it.fixed || it.locked) && it.price > 0;
var priceCell = hasPrice
? '<td class="rfq-li-price">'+money(it.price)+'</td>'
: '<td class="rfq-li-price"><span class="rfq-muted-price">to quote</span></td>';
var lineTotal = hasPrice ? money(it.price * it.qty) : '<span class="rfq-muted-price">&mdash;</span>';
var nameCell;
if (it.fixed || it.locked) {
nameCell = '<div class="rfq-li-item">'+(it.image?'<div class="rfq-li-thumb" style="'+bgUrl(it.image)+'"></div>':'')+'<div><div class="rfq-li-name">'+esc(it.name||"Product")+'</div>'+(it.sku?'<div class="rfq-li-sku">SKU '+esc(it.sku)+'</div>':'')+'</div></div>';
} else {
nameCell = '<div class="rfq-li-item"><div style="flex:1;position:relative"><input type="text" data-name="'+i+'" placeholder="Search our store or type the item" value="'+esc(it.name)+'" autocomplete="off" style="border:1px solid #C9CED7;border-radius:8px;padding:9px 11px;font-size:13.5px;width:100%;box-sizing:border-box"><div class="rfq-sr" data-results="'+i+'"></div></div></div>';
}
var skuCell = (it.fixed || it.locked) ? '' : '<input type="text" data-sku="'+i+'" placeholder="SKU" value="'+esc(it.sku||"")+'" style="border:1px solid #C9CED7;border-radius:8px;padding:9px 11px;font-size:12.5px;width:100%;box-sizing:border-box">';
tr.innerHTML =
'<td>'+nameCell+'</td>'+
'<td class="rfq-li-sku">'+skuCell+'</td>'+
priceCell+
'<td><div class="rfq-stepper"><button type="button" data-dec="'+i+'" aria-label="Decrease">&ndash;</button><input type="text" inputmode="numeric" data-qty="'+i+'" value="'+it.qty+'" aria-label="Quantity"><button type="button" data-inc="'+i+'" aria-label="Increase">+</button></div></td>'+
'<td class="rfq-li-total">'+lineTotal+'</td>'+
'<td>'+(it.fixed?'':'<button type="button" class="rfq-li-remove" data-rm="'+i+'">remove</button>')+'</td>';
rows.appendChild(tr);
});
recalc();
}
function recalc(){
var subtotal = 0, units = 0;
items.forEach(function(it){ units += it.qty; if((it.fixed || it.locked) && it.price > 0) subtotal += it.price * it.qty; });
el=getEl("#subtotal"); if(el) el.textContent=money(subtotal);
el=getEl("#rcTotal"); if(el) el.textContent=money(subtotal);
el=getEl("#rcUnits"); if(el) el.textContent=units;
el=getEl("#rcItems"); if(el) el.textContent=items.length;
}
// ---- Live catalog search for typed rows ----
var srTimer = null;
function doSearch(i, q){
var box = getEl('.rfq-sr[data-results="'+i+'"]');
if (srTimer) clearTimeout(srTimer);
if (!box) return;
if (!q || q.replace(/\s/g,"").length < 2){ box.innerHTML=""; return; }
srTimer = setTimeout(function(){
fetch("/search/suggest.json?q="+encodeURIComponent(q)+"&resources[type]=product&resources[limit]=6")
.then(function(r){ return r.json(); })
.then(function(d){
box = getEl('.rfq-sr[data-results="'+i+'"]');
if (!box) return;
var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
if (!ps.length){ box.innerHTML='<div class="rfq-sr-empty">No catalog match &mdash; we&rsquo;ll quote it as typed.</div>'; return; }
box.innerHTML = ps.map(function(p){
var th = p.image ? '<span class="rfq-sr-thumb" style="'+bgUrl(p.image)+'"></span>' : '';
var pr = p.price ? '<span class="rfq-sr-price">'+money(parseFloat(p.price))+'</span>' : '';
return '<button type="button" class="rfq-sr-item" data-pick="'+i+'" data-url="'+esc(p.url)+'">'+th+'<span class="rfq-sr-name">'+esc(p.title)+'</span>'+pr+'</button>';
}).join("");
})
.catch(function(){});
}, 250);
}
function handlePick(btn){
var i = parseInt(btn.getAttribute("data-pick"),10);
var url = (btn.getAttribute("data-url")||"").split("?")[0];
if (isNaN(i) || !items[i] || !url) return;
btn.disabled = true;
fetch(url+".js")
.then(function(r){ return r.json(); })
.then(function(p){
var it = items[i]; if(!it) return;
var v0 = (p.variants && p.variants[0]) || null;
it.name = p.title || it.name;
it.sku = (v0 && v0.sku) || "";
var cents = v0 ? v0.price : p.price;
it.price = (parseFloat(cents)||0)/100;
it.image = p.featured_image || "";
it.locked = true;
render();
})
.catch(function(){ btn.disabled=false; });
}
document.addEventListener("click", function(e){
var t = e.target;
if (!t.closest || !t.closest(".rfq-li-item")){ getAll(".rfq-sr").forEach(function(b){ b.innerHTML=""; }); }
});
if (rows) {
rows.addEventListener("click", function(e){
var t = e.target;
var pickBtn = t.closest ? t.closest(".rfq-sr-item") : null;
if (pickBtn){ handlePick(pickBtn); return; }
var di = t.dataset.inc, dd = t.dataset.dec, dr = t.dataset.rm;
if(di!=null && di!==""){ items[+di].qty++; render(); }
else if(dd!=null && dd!==""){ items[+dd].qty=Math.max(1,items[+dd].qty-1); render(); }
else if(dr!=null && dr!==""){ items.splice(+dr,1); if(!items.length){items.push({name:"",sku:"",price:0,qty:1,fixed:false});} render(); }
});
rows.addEventListener("input", function(e){
var t = e.target;
if(t.dataset.qty!=null && t.dataset.qty!==""){ items[+t.dataset.qty].qty=Math.max(1,parseInt(t.value.replace(/\D/g,""),10)||1); recalc(); }
else if(t.dataset.name!=null && t.dataset.name!==""){ items[+t.dataset.name].name=t.value; doSearch(+t.dataset.name, t.value); }
else if(t.dataset.sku!=null && t.dataset.sku!==""){ items[+t.dataset.sku].sku=t.value; }
});
}
var addItemBtn = getEl("#addItem");
if (addItemBtn) addItemBtn.addEventListener("click", function(){
items.push({name:"",sku:"",price:0,qty:1,fixed:false}); render();
var inp = getEl('input[data-name="'+(items.length-1)+'"]');
if (inp) inp.focus();
});
var taxEl = getEl("#taxExempt");
if (taxEl) taxEl.addEventListener("change", function(){
var r=getEl("#taxReveal"); if(r) r.classList.toggle("show", this.checked);
});
var asapEl = getEl("#asap");
if (asapEl) asapEl.addEventListener("change", function(){
var d=getEl("#needBy"); if(!d) return;
d.disabled=this.checked; if(this.checked) d.value="";
d.style.opacity=this.checked?.5:1; updateNeed();
});
var needByEl = getEl("#needBy");
var buyerEl = getEl("#buyerType");
if (buyerEl) buyerEl.addEventListener("change", function(){ el=getEl("#rcBuyer"); if(el) el.textContent=this.value||"—"; });
if (needByEl) needByEl.addEventListener("change", updateNeed);
if (asapEl) asapEl.addEventListener("change", updateNeed);
function updateNeed(){
if(asapEl&&asapEl.checked){ el=getEl("#rcNeed"); if(el) el.textContent="ASAP"; return; }
var v=needByEl?needByEl.value:"";
el=getEl("#rcNeed");
if(el) el.textContent=v?new Date(v+"T00:00").toLocaleDateString("en-US",{month:"short",day:"numeric"}):"—";
}
if(window.__CUSTOMER__){
var c=window.__CUSTOMER__;
["name","email","phone","addr","city","state","zip","org"].forEach(function(id){
var f=getEl("#"+id); if(f&&c[id]) f.value=c[id];
});
}
// ---- Validation ----
function clearErrors(){
getAll(".rfq-err").forEach(function(e){e.classList.remove("show");});
getAll(".rfq-invalid").forEach(function(e){e.classList.remove("rfq-invalid");});
}
function showErr(id){
var f=getEl("#"+id); if(f) f.classList.add("rfq-invalid");
var e=getEl('.rfq-err[data-for="'+id+'"]'); if(e) e.classList.add("show");
}
function validEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
function collect(){
return {
buyerType:(buyerEl||{}).value||"",
org:((getEl("#org")||{}).value||"").trim(),
taxExempt:(taxEl||{}).checked||false,
po:((getEl("#po")||{}).value||"").trim(),
name:((getEl("#name")||{}).value||"").trim(),
email:((getEl("#email")||{}).value||"").trim(),
phone:((getEl("#phone")||{}).value||"").trim(),
addr:((getEl("#addr")||{}).value||"").trim(),
city:((getEl("#city")||{}).value||"").trim(),
state:((getEl("#state")||{}).value||"").trim().toUpperCase(),
zip:((getEl("#zip")||{}).value||"").trim(),
payment:(getEl("#payment")||{}).value||"",
needBy:(asapEl&&asapEl.checked)?"ASAP":((needByEl||{}).value||""),
notes:((getEl("#notes")||{}).value||"").trim()
};
}
// Prevent accidental native submit (Enter key) — note: form.submit() bypasses this listener intentionally
var formContainer = document.querySelector('form[action*="/contact"]');
if(formContainer) formContainer.addEventListener("submit",function(e){ e.preventDefault(); });
// ---- Review button ----
var reviewBtn = getEl("#reviewBtn");
if(reviewBtn) reviewBtn.addEventListener("click",function(){
clearErrors();
var d=collect(), bad=[];
if(!d.buyerType) bad.push("buyerType");
if(!d.org) bad.push("org");
if(!d.name) bad.push("name");
if(!validEmail(d.email)) bad.push("email");
if(!d.phone) bad.push("phone");
if(!d.addr) bad.push("addr");
if(!d.city) bad.push("city");
if(!d.state||!d.zip) bad.push("state");
if(!d.payment) bad.push("payment");
if(bad.length){ bad.forEach(showErr); var fe=document.getElementById(bad[0]); if(fe){fe.scrollIntoView({behavior:"smooth",block:"center"});fe.focus({preventScroll:true});} return; }
buildReview(d);
lastData=d;
var ov=getEl("#overlay"); if(ov){ov.classList.add("show");document.body.style.overflow="hidden";}
});
function buildReview(d){
var subtotal=0,ih="";
items.forEach(function(it){
var hasPrice=(it.fixed||it.locked)&&it.price>0;
var lineEst=hasPrice?money(it.price*it.qty):"to quote";
if(hasPrice) subtotal+=it.price*it.qty;
ih+='<tr><td class="rfq-nm">'+esc(it.name||"(unspecified)")+'</td><td>'+esc(it.sku||"—")+'</td><td class="rfq-n">'+it.qty+'</td><td class="rfq-n">'+lineEst+'</td></tr>';
});
var body=
'<div class="rfq-doc-sec"><h5>Items</h5><table class="rfq-doc-items"><thead><tr><th>Item</th><th>SKU</th><th class="rfq-n">Qty</th><th class="rfq-n">Line est.</th></tr></thead><tbody>'+ih+
'</tbody><tfoot><tr><td colspan="3" class="rfq-n" style="border-top:2px solid #14243B;color:#5B6472">Est. subtotal</td><td class="rfq-n" style="border-top:2px solid #14243B;font-weight:600">'+money(subtotal)+'</td></tr></tfoot></table></div>'+
'<div class="rfq-doc-sec"><h5>Buyer</h5><div class="rfq-doc-kv">'+
kv("Type",d.buyerType)+kv("Organization",d.org)+kv("Tax-exempt",d.taxExempt?"Yes — certificate to follow":"No")+(d.po?kv("PO number",d.po):"")+
'</div></div>'+
'<div class="rfq-doc-sec"><h5>Contact &amp; delivery</h5><div class="rfq-doc-kv">'+
kv("Contact",d.name)+kv("Email",d.email)+kv("Phone",d.phone)+
kv("Ship to",d.addr+", "+d.city+", "+d.state+" "+d.zip)+
'</div></div>'+
'<div class="rfq-doc-sec"><h5>Terms</h5><div class="rfq-doc-kv">'+
kv("Payment",d.payment)+kv("Needed by",d.needBy||"Not specified")+(d.notes?kv("Notes",d.notes):"")+
'</div></div>'+
'<div class="rfq-handoff"><b>What happens next:</b> this emails <b>sales@buydirectny.com</b> with your structured RFQ. Your team will reply with a quote within 24 business hours.</div>';
var db=getEl("#docBody"); if(db) db.innerHTML=body;
}
function kv(k,v){ return '<div class="rfq-k">'+esc(k)+'</div><div class="rfq-v">'+esc(v)+'</div>'; }
function closeOverlay(){
var ov=getEl("#overlay"); if(ov) ov.classList.remove("show"); document.body.style.overflow="";
var cw=document.getElementById("confirmWrap"); if(cw){cw.style.display="none";cw.innerHTML="";}
var rw=getEl("#reviewWrap"); if(rw) rw.style.display="";
}
var editBtn=getEl("#editBtn"); if(editBtn) editBtn.addEventListener("click",closeOverlay);
var ov=getEl("#overlay"); if(ov) ov.addEventListener("click",function(e){if(e.target===this) closeOverlay();});
document.addEventListener("keydown",function(e){if(e.key==="Escape") closeOverlay();});
function setH(id,v){var e=document.getElementById(id);if(e) e.value=(v==null?"":v);}
// ---- Send button: use native form.submit() so browser sends CSRF token automatically ----
var sendBtn=getEl("#sendBtn");
if(sendBtn) sendBtn.addEventListener("click",function(){
var d=lastData||collect();
var itxt=items.map(function(it){return it.qty+"x "+(it.name||"(item)")+(it.sku?" [SKU "+it.sku+"]":"")+(((it.fixed||it.locked)&&it.price>0)?" — est "+money(it.price*it.qty):"");}).join("\n");
setH("h_ref",ref);setH("h_email",d.email);setH("h_name",d.name);setH("h_phone",d.phone);
setH("h_buyer",d.buyerType);setH("h_org",d.org);setH("h_tax",d.taxExempt?"Yes — certificate to follow":"No");
setH("h_po",d.po);setH("h_addr",d.addr);setH("h_city",d.city);setH("h_state",d.state);setH("h_zip",d.zip);
setH("h_pay",d.payment);setH("h_need",d.needBy||"Not specified");setH("h_items",itxt);
setH("h_body","RFQ "+ref+"\n\nITEMS:\n"+itxt+"\n\nNotes: "+(d.notes||"—"));
// Persist the request so the confirmation page can show an accurate summary
try { sessionStorage.setItem("rfqLastRequest", JSON.stringify({ ref: ref, date: dateStr, buyer: d.buyerType, needBy: d.needBy||"", items: items.map(function(it){ return { name: it.name, sku: it.sku, price: it.price, qty: it.qty, priced: !!((it.fixed||it.locked) && it.price>0) }; }) })); } catch(e) {}
var f=document.getElementById("rfqForm");
if(!f) return;
sendBtn.disabled=true;
sendBtn.textContent="Sending…";
f.submit();
});
render();
})();
